import { render, staticRenderFns } from "./CompanyAssociatePartnerDashboard.vue?vue&type=template&id=ad89717e"
import script from "./CompanyAssociatePartnerDashboard.vue?vue&type=script&lang=js"
export * from "./CompanyAssociatePartnerDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports